module.exports = __webpack_public_path__ + "static/media/profile.294676ea.jpg";